module.exports = __webpack_public_path__ + "static/media/call.0ec3186a.svg";